import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
// import AddressSelection1 from "./AddressSelection1";
// import PickupView from "./PickupView";
import DeliveryToggle from "../Home/DeliveryToggle";
// import AddressModal from "./AddressModal";
import DeliveryOption from "./DeliveryOption";
import GoogleCustomMap from "../Home/GoogleCustomMap";
import { setDeliveryInstruction } from "../../redux/features/CheckoutAddress";
import { setAddressModal } from "../../redux/features/CheckoutAddress";
import Konsole from "../../utils/konsole/Konsole";
import ParseFloat from "../../utils/ParseFloat";
import AddressGoogleSearch from "./GoogleAddress/AddressGoogleSearch";
import { PICKUP_STATUS,DINNING_STATUS,DELIVERY_STATUS } from "../../utils/helper";
import useCheckBlockPostCode from "../../hooks/useCheckBlockPostCode";
import { toast } from "react-toastify";
import { GetPickupDate } from "../../api/PickupApi";
import useMinimumOrderFees from "../../hooks/useMinimumOrderFees";
export default function DeliveryView() {
  const { t } = useTranslation();

  const {returnStoreRadiousMinimumFees}=useMinimumOrderFees()
  const dispatch = useDispatch();
  const {
    store: { selectedType, selectedStore },
    checkoutAddress,
    // categoryData ,
  } = useSelector((state: any) => state);
  const storeInfo = useSelector((state: any) => state?.store);
  const storeId = storeInfo?.selectedStore?.store_id;

  const IsBlockPostCode = useCheckBlockPostCode()

  Konsole.log("CheckoutAddress", checkoutAddress);



  const returnSelectedAddress = useMemo(() => {
    return checkoutAddress?.selectedAddress;
  }, [checkoutAddress, selectedStore]);

  const disPatch = useDispatch();
  const actionType = 'ADD'

  const handleAddAddressModal = () => {
    // setActionType(Object.keys(returnSelectedAddress)?.length > 0 ? 'EDIT' : 'ADD');

    // setActionType(Object.keys(returnSelectedAddress)?.length > 0 ? 'ADD' : 'ADD');
    // setAddressModal(true)

    disPatch(setAddressModal(true));
  };

  // @@ return true if address
  const hasSelectedAddress = useMemo(() => {
    const hasAddress = Object?.keys(returnSelectedAddress)?.length > 0;
    return hasAddress;
  }, [returnSelectedAddress]);
  const handleAddressModalClose = () => {
    disPatch(setAddressModal(false));
  };

  useEffect(() => {
    GetPickupDate(dispatch, storeId);
    if (IsBlockPostCode(returnSelectedAddress?.zip_code)) {
      toast.error("We cannot deliver to this address.")
    }
  }, [returnSelectedAddress?.zip_code])


  Konsole.log("selectedType", selectedStore, selectedType);
  return (
    <div>
      {/* @@START Delivery and Pickup options */}
      <div className="store-card checkout">
        <div className="flex justify-between lg:flex-row flex-col-reverse lg:items-center gap-1">
          <p
          //  className="text-xl font-splekta font-normal mobile-checkout-head  mb-2 md:mb-0" 
          className={`text-xl font-splekta font-normal mobile-checkout-head ${selectedType == 1 ? "":" mb-2 md:mb-0"}`}
          >
            {selectedType == 1 ? selectedStore?.store_name : t("MyOrders.deliveryAddress")}
          </p>
          {(selectedType == 3 && returnStoreRadiousMinimumFees && returnStoreRadiousMinimumFees > 0) ?
            <div className="text-left md:text-right me-2 block lg:hidden cardDesciption" >{t("Checkout.minimumOrderFee")} <b>{ParseFloat(returnStoreRadiousMinimumFees)}</b></div> : null}
          {/* @@ toggle of Pickup and delivery  */}
          <DeliveryToggle
            onSelectionChange={(value) => Konsole.log(value)}
            defaultValue={""}
          />
        </div>
        {(selectedType == 3 && returnStoreRadiousMinimumFees && returnStoreRadiousMinimumFees > 0 ) ?
          <div className="text-left md:text-right  me-2 hidden lg:block cardDesciption" >{t("Checkout.minimumOrderFee")} <b>{ParseFloat(returnStoreRadiousMinimumFees)}</b></div> : null}

        {/* @@ Pickup address content */}
        {selectedType == 1 ? (
          <>
            <div className="mb-5 md:mt-5 mobile-map-hide">
              <GoogleCustomMap />
            </div>
            <DeliveryOption orderType={"pickup"} />
            {/* @@END Pickup address */}
          </>
        ) : selectedType == DELIVERY_STATUS ? (
          <>
            {/* @@START Delivery address */}
            <div
              className="flex justify-between md:mb-6 mb-3 cursor-pointer items-stretch md:mt-3"
              onClick={() => handleAddAddressModal()}
            >
              <div className="flex w-[70%] items-center gap-6">
                <img src="/images/address-icon.svg" />
                <p className="textMd font-medium two-line-truncate" >
                  {Object.keys(returnSelectedAddress)?.length > 0 ? (
                    <>
                      {" "}
                      {/* {returnSelectedAddress?.zip_code ? `${returnSelectedAddress?.zip_code}-`:''} */}
                             {returnSelectedAddress?.house_no ? `${returnSelectedAddress?.house_no} ,`:''}
                      {returnSelectedAddress?.full_address}{" "}
                    </>
                  ) : (
                    "Select an address"
                  )}
                </p>
              </div>
              <div className="flex w-[30%] items-center justify-end">
                <button className="bg-white text-black border border-black font-medium rounded-lg text-sm px-5 py-1.5 text-center inline-flex items-center">

                  {/* @@ for mobile screen */}
                  <span className="block lg:hidden">
                    {hasSelectedAddress ? t("change") : t("MyAddress.select")}
                  </span>

                  {/* For larger screens */}
                  <span className="hidden lg:block">
                    {hasSelectedAddress ? t("MyAddress.changeAddress") : t("MyAddress.selectAddress")}
                  </span>
                  {/* <svg
                    className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg> */}
                </button>
              </div>
            </div>

            {/* @@ ERROR MESSAGE */}
            {/* <p className="text-[#ED2323] textMd font-normal">
                Sorry, We doesn't provide delivery in this area
              </p> */}
            <hr className="mt-2 mb-4 border-t border-[#E2E2E2] md:mx-0 -mx-4" />
            <div className="flex gap-6">
              <img src="/images/instruction-icon.svg" />
              <input
                className="w-full border-2 border-[#E7E7E7] bg-white rounded-lg py-3 px-3 textMd input-box-zoom"
                type="text"
                value={checkoutAddress?.deliveryInstruction}
                placeholder="Add Delivery Instructions"
                onChange={(e) =>
                  disPatch(setDeliveryInstruction(e.target.value))
                }
              />
            </div>
            {/* <hr className="mt-4 mb-4 border-t-2 border-[#E2E2E2] md:mx-0 -mx-4" /> */}
            <DeliveryOption orderType={"delivery"} />

            {/* @@END Delivery address */}
          </>
        ) : null}
      </div>

      {/* <AddressModal
        refrencePage="DeliveryView"
        key={`${checkoutAddress?.addressModal}+1`}
        addressModal={checkoutAddress?.addressModal}
        actionType={actionType}
        selectedAddress={returnSelectedAddress}
        setAddressModal={handleAddressModalClose}
      /> */}
      <AddressGoogleSearch
        refrencePage="DeliveryView"
        key={`${checkoutAddress?.addressModal}+1`}
        addressModal={checkoutAddress?.addressModal}
        actionType={actionType}
        selectedAddress={returnSelectedAddress}
        setAddressModal={handleAddressModalClose}
      />
    </div>
  );
}
